import { Box, styled } from "@mui/material";
import { PanelResizeHandle } from "react-resizable-panels";

export const LeftHeaderContainer = styled(Box)(() => ({
  padding: "0 1.5rem 0 0",
  display: "flex",
  alignItems: "center",
}));

export const SidebarIconContainer = styled(Box)(({ theme }) => ({
  cursor: "pointer",
  display: "flex",
  padding: "0.3rem .4rem",
  borderRadius: "8px",
  backgroundColor: theme.palette.primary.outline,
  marginLeft: ".5rem",
  marginRight: "1rem",
}));

export const BrightbotIconContainer = styled(Box)(() => ({
  svg: {
    width: "40px",
    height: "40px",
    marginRight: ".5rem",
  },
}));

export const RightHeaderContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  width: " 100%",
  paddingRight: "5rem",
  justifyContent: "flex-end",
}));

export const ContentContainer = styled(Box)(({}) => ({
  display: "flex",
  flex: "1",
  height: "100%",
  marginTop: "-1.15rem",
}));

export const ChatContainer = styled(Box)(({}) => ({
  height: "100%",
  display: "flex",
  flex: "1",
  minHeight: "300px",
}));

export const CustomPanelResizeHandle = styled(PanelResizeHandle)(
  ({ theme }) => ({
    backgroundColor: theme.palette.primary.main,
    height: "100%",
    float: "right",
    width: "7px",
    "&[data-resize-handle-state='inactive']": {
      width: "3px",
    },
  })
);

export const StyledPanelResizerContainer = styled(Box)({
  width: "7px",
  height: "100%",
  marginLeft: "-5px",
  zIndex: "100000",
});
